import 'default-passive-events'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/element.js'
import Element from 'element-ui'
import md5 from 'js-md5'
import { VueJsonp } from 'vue-jsonp'
import 'element-ui/lib/theme-chalk/index.css'
import axios from 'axios'   // ⚠️ 你缺少了这一行
import { isTokenExpired } from './utils/auth'


Vue.use(Element)
Vue.use(VueJsonp)

Vue.prototype.$md5 = md5
Vue.prototype.h = 2
Vue.config.productionTip = false

import { Message } from 'element-ui'

// axios 全局配置
Vue.prototype.$http = axios
axios.defaults.baseURL = process.env.VUE_APP_BASE_API
axios.defaults.withCredentials = true

let isRedirectingLogin = false
const authExpiredCodes = [401, 5104]

const clearAuthAndGoLogin = (message = "登录失效") => {
  store.commit('clearAuth')

  if (!isRedirectingLogin) {
    isRedirectingLogin = true
    Message.error(message)
    setTimeout(() => {
      isRedirectingLogin = false
    }, 1500)
  }

  if (router.currentRoute.path !== "/login") {
    router.push("/login").catch(() => {})
  }
}

// 响应拦截
axios.interceptors.response.use(function (response) {
    if (response.data && authExpiredCodes.includes(Number(response.data.code))) {
        clearAuthAndGoLogin(response.data.code === 5104 ? "登录授权异常，请重新登录" : "登录失效")
        return Promise.reject(response);
    }

// 这个是处理响应成功的结果，也就是说响应状态码为2XX系列的
    return response;
},function (error) {
// 这个是处理响应失败的，也就是响应错误的，在这个箭头函数中，才能拿到401状态下的包
    if (error.response && error.response.status === 401) {
        clearAuthAndGoLogin("登录失效")
    }
    return Promise.reject(error);
});


/*
axios.interceptors.response.use((data) => {
    console.log("success:", data)
    if (data.data.code === 200) {
        return data
    }
    if (data.data.code === 401) {
        /!*window.localStorage.removeItem("token")
        router.push("/login")
        return *!/
        Message.error("错误")
    }
}, error => {
    debugger
    console.log("error:", error)
    if (error.response.status === 401) {
        // 接口的根地址截取下来，判断
        const url = error.response.config.url
        const flag = url.substring(0, url.indexOf('/'))
        // 判断地址是哪一个页面的，push到相应的错误页面
        if (flag == 'roster') {
            router.push({
                path: '/rosterError',
                query: {
                    info: error.response.data.message
                }
            })
        }
        if (flag == 'user') {
            router.push({
                path: '/AllUserinfoEerror',
                query: {
                    info: error.response.data.message
                }
            })
        }
    }

})*/
//验证手机号
Vue.prototype.checkPhone = (phone) => {
    if (!(/^1[3456789]\d{9}$/.test(phone))) {
        return false;
    }
    return true;
}

// 添加请求拦截器
// 请求拦截器
axios.interceptors.request.use((config) => {
  let token = window.localStorage.getItem('token')
  if (isTokenExpired()) {
    clearAuthAndGoLogin("登录已过期，请重新登录")
    return Promise.reject(new Error("token expired"))
  }
  if (token) {
    config.headers = config.headers || {}
    config.headers['token'] = token
  }
  return config
}, (error) => {
  return Promise.reject(error)
})

// 响应拦截器
axios.interceptors.response.use((response) => {
    if (response.data.code == 5000) {
        return Message.error("系统异常")
    } else {
        return response
    }
  if (response.data.code == 5000) {
    Message.error("系统异常")
    return Promise.reject(response)
  }
  return response
}, (err) => {
  if (err.response && err.response.data && err.response.data.errorCode) {
    Message.error(err.response.data.msg)
  }
  return Promise.reject(err)
})

// 🌍 根据域名设置全局变量
const host = window.location.hostname
let componyName = ""
let kfWechat=""
let componeyAddr=""
let emailAddr=""

if (host === "a.moguvps.com") {
  componyName = "江苏蘑菇云信息技术有限公司防城港分公司"
  kfWechat = require("@/assets/picture/a.kf.png"); 
  componeyAddr="江苏蘑菇云信息技术有限公司防城港分公司"
  emailAddr="3966616218@qq.com"
} else {
  componyName = "江苏蘑菇云信息技术有限公司"
  kfWechat = require("@/assets/picture/a.kf.png"); 
  componeyAddr="徐州市铜山区利国镇府前路36号"
  emailAddr="3573523259@qq.com"
}

// Vue2 正确写法
Vue.prototype.$componyName = componyName
Vue.prototype.$kfWechat = kfWechat
Vue.prototype.$componeyAddr = componeyAddr
Vue.prototype.$emailAddr = emailAddr

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
